module.exports = __webpack_public_path__ + "media/images/emblems/Corseaux-coat_of_arms-7648d8e60195913d916dd5f529b55fa5.svg";